import React from "react";
import { Box } from "@mui/system";
import Loader from "components/loader";
import { ReducersModal } from "utils/modals";
import { useDispatch, useSelector } from "react-redux";
import { deleteVechile, getVehicleList } from "./action";
import AddNewVehicleyModal from "modules/utilityManagement/addNewVehicle";
import VehicleTable from "components/tables/vehicleTable";
import { UPDATE_CAR_LIST_REDUCER } from "store/actionTypes";

const Vehicle = () => {
  const dispatch: any = useDispatch();
  const { vehicles } = useSelector(
    (state: ReducersModal) => state.CarCompanyReducer
  );
  const [open, setOpen] = React.useState(false);
  const [selectedCompany, setSelectedCompany] = React.useState(null);
  const { isLoading, pagination, result, search = "" } = vehicles;
  const { page = 1, limit = 10, totalRecords = 0 } = pagination || {};
  const recordsCount = Math.max(totalRecords || 0, result?.length || 0);

  React.useEffect(() => {
    dispatch(getVehicleList(() => {}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page, limit, search]);

  const dispatchValue = (payload: any) => {
    dispatch({
      type: UPDATE_CAR_LIST_REDUCER,
      payload,
    });
  };
  const searchHandler = (text: string) => {
    const nextSearch = `${text || ""}`.trim();
    dispatchValue({
      vehicles: {
        ...vehicles,
        search: nextSearch,
        pagination: { ...pagination, page: 1 },
      },
    });
  };

  const handleChangePage = (newPage: any) => {
    dispatchValue({
      vehicles: {
        ...vehicles,
        pagination: { ...pagination, page: newPage + 1 },
      },
    });
  };

  const handleChangeRowsPerPage = (numberOfRows: any) => {
    dispatchValue({
      vehicles: {
        ...vehicles,
        pagination: { ...pagination, page: 1, limit: numberOfRows },
      },
    });
  };

  const onEditPress = (vechile: any) => {
    setSelectedCompany(vechile);
    setOpen(true);
  };
  const onDeletePress = (vechile: any) => {
    dispatch(deleteVechile({ callback: () => {}, data: { id: vechile.id } }));
  };

  return (
    <Box>
      <VehicleTable
        carCompaniesList={result}
        currentPage={page}
        onEditPress={onEditPress}
        onDeletePress={onDeletePress}
        onAddPress={() => {
          setSelectedCompany(null);
          setOpen(true);
        }}
        rowsPerPage={limit}
        handleChangePage={handleChangePage}
        totalRecords={recordsCount}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        searchHandler={searchHandler}
      />
      <AddNewVehicleyModal
        selectedVehicle={selectedCompany}
        state={open}
        setState={setOpen}
      />
      {isLoading && <Loader />}
    </Box>
  );
};
export default Vehicle;
